import forexCalculator from "./forex-calculator";

// forexCalculator();